export const DEFAULT_RENEWAL_AVAILABLE_IN_DAYS = 90;

let runtimeRenewalAvailableInDays: number | null = null;

const normalizeRenewalAvailableInDays = (value: unknown): number | null => {
  const parsed = Number.parseInt(String(value ?? ''), 10);

  return Number.isNaN(parsed) || parsed <= 0 ? null : parsed;
};

export const setRenewalAvailableInDays = (value?: number | string | null): void => {
  runtimeRenewalAvailableInDays = normalizeRenewalAvailableInDays(value);
};

export const getRenewalAvailableInDays = (): number =>
  runtimeRenewalAvailableInDays ??
  normalizeRenewalAvailableInDays(process.env.REACT_APP_RENEWAL_AVAILABLE_IN_DAYS) ??
  DEFAULT_RENEWAL_AVAILABLE_IN_DAYS;
